// extracted by mini-css-extract-plugin
export default {"icon":"MetricRowSimple_icon__9DcRn"};